import React, { FC, useRef } from 'react';
import styled from 'styles/styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import media from 'utils/mediaStyle';
import messages from '../messages';

import SVGIcon from 'components/SVGIcon/SVGIcon';
import { Viewport } from 'components/ViewportProvider';
import { FormattedMessage } from 'react-intl';
import { Autoplay, Navigation } from 'swiper/modules';
import {
  WorkProcess1,
  allocation,
  allocationIcon,
  arrowNav,
  preservation,
  preservationIcon,
  purchase,
  qualityControl,
  qualityControlIcon,
  transport,
  transportIcon,
} from '../Images';
import { SectionContainer, SectionTitle, SectionTitleBox } from './Partners';
import { commonDimensions } from 'utils/constants';

const Container = styled.div`
  @media (max-width: 1023px) {
    padding: 0 16px;
  }
`;

const SwiperElementContainer = styled.div`
  max-width: ${commonDimensions.MAX_WIDTH_CONTAINER - 80}px;
  margin: 0 auto;
  overflow: visible;
  position: relative;
  height: fit-content;
  ${media.md`
    padding-left: 16px;
    `}
`;

const SwiperElement = styled(Swiper)`
  transform: translateX(-16px);
  // overflow: visible;
  margin: 0px !important;
  padding: 0px 16px 140px !important;
  .swiper-button-prev.swiper-button-disabled {
    display: none !important;
  }
  .swiper-button-prev.swiper-button-disabled {
    display: none !important;
  }
  .swiper-button-next,
  .swiper-button-prev {
    display: none;
    &.swiper-button-disabled {
      display: none !important;
    }
  }
  ${media.md`
    padding: 10px 5px 140px !important;
    `}
  @media(max-width: 1600px) {
    width: 100vw;
    max-width: unset;
  }
`;

const SwiperSlideElementContainer = styled.div`
  transition: transform 0.3s ease;
  transform: translateZ(0) scale(1) !important;
  ${media.md`
    &:hover {
      transform: translateZ(0) scale(1.02) !important;
    }
    `}
`;

const SwiperSlideElement = styled(SwiperSlide)`
  width: 100%; !important;
  position: relative;
  cursor: pointer;
  &:last-child {
    margin-right: 200px;
  }
  @media (max-width: ${commonDimensions.MAX_WIDTH_CONTAINER}px) {
    &:last-child {
      margin-right: 50px;
    }
  }
  ${media.md`
    width: fit-content !important;
    `}

  @media (max-width: 767px) {
    &:after {
      content:'';
      position: absolute;
      top: 111.9%;
      height: 1px;
      width: 120%;
      background: #b6e1b9;
      z-index: 1;
    }
    &:first-child:after {
      left: 50%;
      width: 60%;
      background: #b6e1b9;
      z-index: 1;
    }
  }
  @media(min-width: 1600px) {
    &:last-child {
      margin-right: 0px;
    }
  }
`;

const SwiperOrderWrapper = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 110%;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 10;
  ${media.md`
    top: 115%;
    `}
`;

const SwiperOrderNumber = styled.div`
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: 48px;
  color: #d4edd5;
  margin-top: 24px;
`;

const SwiperOrderDot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #43a047;
`;

const SwiperSlideImageWrapper = styled.div`
  display: flex;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  padding-top: 68%;
  overflow: hidden;
  ${({ image }) => image && `background: url(${image});`}
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  ${media.md`
    width: 350px;
    // height: 238px;
    `}
`;

const SwiperSlideTextbox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: #f0f9f1;
  height: 72px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  ${media.md`
    max-width: 350px;
    height: 112px;
    padding: 32px;
    `}
`;

const SwiperSlideText = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: #000000;
  flex-grow: 1;
  display: -webkit-inline-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: anywhere;
  ${media.md`
    font-size: 16px;
    line-height: 24px;
    `}
`;

const SwiperSlideIcon = styled(SVGIcon)``;

const BottomLine = styled.div`
  position: relative;
  top: -81px;
  height: 1px;
  width: 100%;
  background: #b6e1b9;
`;

const NavigationButtonWrapper = styled.div`
  gap: 24px
  display: flex;
  align-items: center;
  justify-content: center;
  ${media.md`
    margin-top: 40px;
    `}
`;

const NavigationButton = styled.div`
  height: 44px;
  width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 80px;
  border: 2px solid #43a047;
  cursor: pointer;
  ${({ disabled }) =>
    disabled &&
    `
    border: 1px solid #b6e1b9;
    cursor: initial;
  `}
  ${media.md`
    height: 56px;
    width: 56px;
    `}
  &:hover {
    background: #f0f9f1 !important;
  }
  &:active {
    background: #d4edd5 !important;
  }
`;

const NavigationButtonIcon = styled(SVGIcon)`
  ${({ disabled }) => disabled && `filter: opacity(0.5);`}
`;

const WorkProcessCarousel: FC<any> = () => {
  const lang = localStorage.getItem('lang') || 'vi';
  const swiperRef: any = useRef();
  const data = [
    {
      id: 1,
      img: purchase,
      description: messages.purchase,
      descriptionIcon: WorkProcess1,
    },
    {
      id: 2,
      img: transport,
      description: messages.transport,
      descriptionIcon: transportIcon,
    },
    {
      id: 3,
      img: allocation,
      description: messages.allocation,
      descriptionIcon: allocationIcon,
    },
    {
      id: 4,
      img: preservation,
      description: messages.preservation,
      descriptionIcon: preservationIcon,
    },
    {
      id: 5,
      img: qualityControl,
      description: messages.qualityControl,
      descriptionIcon: qualityControlIcon,
    },
  ];
  return (
    <Viewport.Consumer>
      {({ width }) => {
        const isNotMobile = width > 767;
        return (
          <SectionContainer id="PROCESS">
            <Container>
              <SectionTitleBox>
                {lang === 'vi' ? (
                  <>
                    <SectionTitle>Cách Kamereo&nbsp;</SectionTitle>
                    <SectionTitle highLight>kết nối nông trại với doanh nghiệp</SectionTitle>
                  </>
                ) : (
                  <>
                    <SectionTitle>
                      How Our
                      <SectionTitle highLight>&nbsp;Farm-to-Business </SectionTitle>
                    </SectionTitle>
                    <SectionTitle>Model Works</SectionTitle>
                  </>
                )}
              </SectionTitleBox>
              <SwiperElementContainer>
                <SwiperElement
                  onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                  }}
                  slidesPerView={isNotMobile ? 'auto' : 1.1}
                  spaceBetween={24.5}
                  navigation={true}
                  modules={[Navigation, Autoplay]}
                  className="process"
                  loop={true}
                  // autoplay={
                  //   isNotMobile
                  //     ? {
                  //         delay: 3000,
                  //         disableOnInteraction: false,
                  //         pauseOnMouseEnter: true,
                  //       }
                  //     : false
                  // }
                >
                  {data.map((item, index) => (
                    <SwiperSlideElement key={index}>
                      <SwiperSlideElementContainer>
                        <SwiperSlideImageWrapper image={item.img}>
                          {/* <SwiperSlideImage src={item.img} /> */}
                        </SwiperSlideImageWrapper>
                        <SwiperSlideTextbox>
                          <SwiperSlideIcon src={item.descriptionIcon} />
                          <SwiperSlideText>
                            <FormattedMessage {...item.description} values={{ break: <br /> }} />
                          </SwiperSlideText>
                        </SwiperSlideTextbox>
                      </SwiperSlideElementContainer>
                      <SwiperOrderWrapper>
                        <SwiperOrderDot />
                        <SwiperOrderNumber>0{index + 1}</SwiperOrderNumber>
                      </SwiperOrderWrapper>
                    </SwiperSlideElement>
                  ))}
                </SwiperElement>
              </SwiperElementContainer>
              {isNotMobile && <BottomLine />}
              {!isNotMobile && (
                <NavigationButtonWrapper>
                  <NavigationButton
                    onClick={() => {
                      swiperRef.current.slidePrev();
                    }}
                  >
                    <NavigationButtonIcon src={arrowNav} style={{ transform: 'rotate(180deg)' }} />
                  </NavigationButton>
                  <NavigationButton
                    onClick={() => {
                      swiperRef.current.slideNext();
                    }}
                  >
                    <NavigationButtonIcon src={arrowNav} />
                  </NavigationButton>
                </NavigationButtonWrapper>
              )}
            </Container>
          </SectionContainer>
        );
      }}
    </Viewport.Consumer>
  );
};

export default WorkProcessCarousel;
